import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import * as icons from '@/components/icons'
import pt from 'vuetify/es5/locale/pt'

const ICONS = {
  'big-risk': {
    component: icons.bigRisk
  },
  branch: {
    component: icons.branch
  },
  rest: {
    component: icons.rest
  },
  risk: {
    component: icons.risk
  },
  shadow: {
    component: icons.shadow
  },
  stop: {
    component: icons.stop
  }
}

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { pt },
    current: 'pt'
  },
  theme: {
    themes: {
      // light: {
      //   primary: '#2196F3',
      //   secondary: '#424242',
      //   accent: '#82B1FF',
      //   error: '#d567bd',
      //   info: '#53A4CF',
      //   success: '#70d32e',
      //   warning: '#ffba2b',
      // },
      light: {
        whatsapp: '#25D366'
      }
    }
  },
  icons: {
    iconfont: 'mdi',
    values: ICONS
  }
})
